"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGrid4 as smGrid,
  faGrid2 as lgGrid,
  faDiagramCells as lgRow,
} from "@fortawesome/pro-thin-svg-icons";
import { Button } from "@/components/button";

const sortTypes = [
  { value: "featured", label: "Featured" },
  { value: "recent", label: "Most Recent" },
  { value: "viewed", label: "Most Viewed" },
  { value: "useful", label: "Most Useful" },
];

export function SortLayoutBox({ sort, onSort, layout, onLayout }) {
  return (
    <div className="flex justify-between items-center">
      <select
        className="min-w-[200px] block rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
        value={sort}
        onChange={({ target }) => onSort(target.value)}
      >
        {sortTypes.map(({ value, label }, index) => (
          <option key={index} value={value}>
            {label}
          </option>
        ))}
      </select>

      <div className="flex space-x-2">
        <Button
          className="w-8 h-8"
          variant={
            layout.variant === "grid" && layout.size === "sm" ? "ghost" : "link"
          }
          onClick={() => onLayout({ variant: "grid", size: "sm" })}
        >
          <FontAwesomeIcon className="text-2xl" icon={smGrid} />
        </Button>
        <Button
          className="w-8 h-8"
          variant={
            layout.variant === "grid" && layout.size === "lg" ? "ghost" : "link"
          }
          onClick={() => onLayout({ variant: "grid", size: "lg" })}
        >
          <FontAwesomeIcon className="text-2xl" icon={lgGrid} />
        </Button>
        <Button
          className="w-8 h-8"
          variant={
            layout.variant === "row" && layout.size === "lg" ? "ghost" : "link"
          }
          onClick={() => onLayout({ variant: "row", size: "lg" })}
        >
          <FontAwesomeIcon className="text-2xl" icon={lgRow} />
        </Button>
      </div>
    </div>
  );
}
